import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded";
import { Box, Tooltip, Typography } from "@mui/material";
import { useCompanyTimeZone } from "../hooks/useCompanyTimeZone";

export const CompanyTimeCaption = () => {
  const { timeZone, city } = useCompanyTimeZone();

  return (
    <Tooltip title={timeZone} arrow>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          gap: 0.5,
          mt: 1,
          color: "text.secondary",
        }}
      >
        <AccessTimeRoundedIcon
          sx={{ fontSize: 14, color: "#ff8912", display: "block", flexShrink: 0, transform: "translateY(-1px)" }}
        />
        <Typography variant="caption" sx={{ fontSize: "0.7rem", lineHeight: 1.2 }}>
          Calendar shown in{" "}
          <Box component="span" sx={{ fontWeight: 700 }}>
            company time zone
          </Box>
          :{" "}
          <Box component="span" sx={{ fontWeight: 700 }}>
            {city}
          </Box>
          .
        </Typography>
      </Box>
    </Tooltip>
  );
};
